import { render, staticRenderFns } from "./admin-countries.vue?vue&type=template&id=46c90949&scoped=true"
import script from "./admin-countries.vue?vue&type=script&lang=js"
export * from "./admin-countries.vue?vue&type=script&lang=js"
import style0 from "./admin-countries.vue?vue&type=style&index=0&id=46c90949&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c90949",
  null
  
)

export default component.exports